window.matchInvitationData = function () {
    return {
        sent: {
            show: false, waiting: false, opponent: null, matchId: null,
            timeRemaining: 0, status: '', message: '',
            hasDelayProposal: false, proposedDelay: null, delayInfo: null
        },
        received: {
            show: false, opponent: null, matchId: null,
            opponentClub: null, opponentLogo: null,
            ranking: null, courtesyRating: null, reputation: null, teamStars: null, passAssistance: null,
            championship: null, division: null, group: null,
            isFriendly: false,
            showDelayChoice: false, selectedDelay: 15, delayInfo: null,
            timeRemaining: 0, invitationKey: null
        },
        // Invitation déjà écartée (fermée, refusée, délai proposé) : le sondage de
        // la sidebar la renvoie toutes les 15 s, elle ne doit pas revenir à l'écran.
        dismissedInvitationKey: null,
        rankingSent: {
            show: false, waiting: false, rankingMatchId: null,
            opponent: null, status: '', message: '', isFriendly: false,
            hasDelayProposal: false, proposedDelay: null, delayInfo: null, timeRemaining: 0
        },
        rankingReceived: {
            show: false, rankingMatchId: null,
            opponentName: null, masterRanking: null,
            courtesyRating: null, passAssistance: null, isFriendly: false,
            challengeMode: null,
            showDelayChoice: false, selectedDelay: 15,
            timeRemaining: 0
        },
        checkInterval: null,
        delayTimerInterval: null,
        receivedTimerInterval: null,
        rankingCheckInterval: null,
        rankingDelayTimerInterval: null,
        rankingReceivedTimerInterval: null,

        init() {
            let self = this;

            window.addEventListener('ranking-invitation-sent', function (e) {
                self.rankingSent = {
                    show: true, waiting: true,
                    rankingMatchId: e.detail.rankingMatchId,
                    opponent: e.detail.opponent,
                    isFriendly: e.detail.isFriendly || false,
                    status: 'waiting', message: 'En attente de réponse...'
                };
                self.startRankingPolling();
            });

            window.addEventListener('pending-ranking-invitation', function (e) {
                let inv = e.detail;
                if (self.rankingReceived.show && self.rankingReceived.rankingMatchId === inv.ranking_match_id) return;
                self.rankingReceived = {
                    show: true,
                    rankingMatchId: inv.ranking_match_id,
                    opponentName: inv.opponent_name,
                    masterRanking: inv.master_ranking,
                    courtesyRating: inv.courtesy_rating,
                    passAssistance: inv.pass_assistance,
                    fumaFriendly: inv.fuma_friendly || false,
                    isFriendly: inv.is_friendly || false,
                    challengeMode: inv.challenge_mode || null,
                    showDelayChoice: false, selectedDelay: 15,
                    timeRemaining: (typeof inv.time_remaining === 'number') ? inv.time_remaining : 0
                };
                // Décompte d'expiration de la demande de défi (uniquement si le
                // serveur a fourni un temps restant — pas en cas de délai négocié).
                if (self.rankingReceived.timeRemaining > 0) {
                    self.startRankingReceivedTimer();
                }
            });

            window.addEventListener('match-invitation-sent', function (e) {
                self.sent = {
                    show: true, waiting: true,
                    opponent: e.detail.opponent, matchId: e.detail.matchId,
                    isGambardella: e.detail.isGambardella || false,
                    timeRemaining: 0, status: 'waiting', message: 'En attente de réponse...',
                    hasDelayProposal: false, proposedDelay: null, delayInfo: null
                };
                self.startPolling();
            });

            window.addEventListener('pending-match-invitation', function (e) {
                let inv = e.detail;
                if (self.received.show && self.received.matchId === inv.match_id) return;
                if (self.invitationKey(inv) === self.dismissedInvitationKey) return;
                self.received = {
                    show: true,
                    opponent: inv.opponent_name, matchId: inv.match_id,
                    opponentClub: inv.opponent_club, opponentLogo: inv.opponent_logo,
                    ranking: inv.ranking || null,
                    courtesyRating: inv.courtesy_rating || null,
                    reputation: inv.reputation ?? 0,
                    teamStars: inv.team_stars ?? null,
                    passAssistance: inv.pass_assistance || null,
                    championship: inv.championship, division: inv.division, group: inv.group,
                    isFriendly: inv.is_friendly || false,
                    isGambardella: inv.is_gambardella || false,
                    showDelayChoice: false, selectedDelay: 15,
                    delayInfo: inv.delay_info || null,
                    timeRemaining: inv.delay_info ? inv.delay_info.time_remaining : 0,
                    invitationKey: self.invitationKey(inv)
                };
                if (inv.delay_status === 'accepted' && inv.delay_info) {
                    self.startReceivedTimer();
                }
            });
        },

        /**
         * Clé d'une demande : le match ET l'heure de la demande, pour qu'une
         * nouvelle invitation sur le même match repasse à l'écran.
         */
        invitationKey(inv) {
            return inv.match_id + '@' + (inv.invited_at || '');
        },

        /**
         * Fermer le popup reçu sans y répondre : on retient la demande écartée.
         */
        dismissReceivedPopup() {
            this.stopReceivedTimer();
            this.dismissedInvitationKey = this.received.invitationKey || null;
            this.received.show = false;
            this.received.showDelayChoice = false;
        },

        startReceivedTimer() {
            this.stopReceivedTimer();
            let self = this;
            this.receivedTimerInterval = setInterval(function () {
                if (self.received.timeRemaining > 0) {
                    self.received.timeRemaining--;
                } else {
                    self.stopReceivedTimer();
                    // Le créneau est passé : le serveur purge la demande, le popup n'a plus lieu d'être.
                    self.dismissReceivedPopup();
                }
            }, 1000);
        },

        stopReceivedTimer() {
            if (this.receivedTimerInterval) { clearInterval(this.receivedTimerInterval); this.receivedTimerInterval = null; }
        },

        startPolling() {
            let self = this;
            this.stopPolling();
            this.checkInterval = setInterval(function () {
                fetch('/notifications/check-match-invitation?match_id=' + self.sent.matchId)
                    .then(r => r.json())
                    .then(data => {
                        if (!data.success || data.status === 'waiting') return;
                        self.stopPolling();
                        self.sent.status = data.status;
                        self.sent.message = data.message;
                        self.sent.waiting = false;

                        if (data.status === 'accepted') {
                            setTimeout(() => { window.location.href = '/matches/' + self.sent.matchId + '/live'; }, 2000);
                        } else if (data.status === 'delay_proposed') {
                            self.sent.hasDelayProposal = true;
                            self.sent.proposedDelay = data.message.match(/\d+/)?.[0];
                        } else if (data.status === 'delay_waiting' && data.delay_info) {
                            self.sent.delayInfo = data.delay_info;
                            self.sent.timeRemaining = data.delay_info.time_remaining;
                            self.startDelayTimer();
                        } else if (data.status === 'delay_expired') {
                            setTimeout(() => { window.location.href = '/matches/' + self.sent.matchId + '/live'; }, 2000);
                        }
                    })
                    .catch(err => console.error(err));
            }, 3000);
        },

        stopPolling() {
            if (this.checkInterval) { clearInterval(this.checkInterval); this.checkInterval = null; }
        },

        closeSentPopup() {
            this.stopPolling();
            this.sent.show = false;
        },

        acceptInvitation(matchId) {
            let self = this;
            this.stopReceivedTimer();
            this._postMatch('/notifications/respond-to-match-invitation', { match_id: matchId, accept: true }, data => {
                if (data.success && data.redirect) window.location.href = data.redirect;
            });
        },

        refuseInvitation(matchId) {
            let self = this;
            this._postMatch('/notifications/respond-to-match-invitation', { match_id: matchId, accept: false }, data => {
                if (data.success) self.dismissReceivedPopup();
            });
        },

        proposeDelay(matchId, minutes) {
            let self = this;
            this._postMatch('/notifications/respond-to-match-invitation', { match_id: matchId, propose_delay: minutes }, data => {
                if (data.success) self.dismissReceivedPopup();
            });
        },

        respondToDelay(matchId, accept) {
            let self = this;
            this._postMatch('/notifications/respond-to-delay-proposal', { match_id: matchId, accept: accept }, data => {
                if (!data.success) return;
                self.sent.hasDelayProposal = false;
                if (accept && data.delay_info) {
                    self.sent.message = 'Délai accepté. En attente...';
                    self.sent.status = 'delay_accepted';
                    self.sent.delayInfo = data.delay_info;
                    self.sent.timeRemaining = data.delay_info.time_remaining;
                    self.startDelayTimer();
                } else {
                    self.sent.message = 'Délai refusé.';
                    self.sent.status = 'delay_refused';
                    self.sent.waiting = false;
                }
            });
        },

        startDelayTimer() {
            this.stopDelayTimer();
            let self = this;
            this.delayTimerInterval = setInterval(function () {
                if (self.sent.timeRemaining > 0) {
                    self.sent.timeRemaining--;
                } else {
                    self.stopDelayTimer();
                    self.sent.message = 'Le délai est passé. Vous pouvez refaire une nouvelle demande.';
                    self.sent.status = 'delay_expired';
                    self.sent.delayInfo = null;
                    self.sent.waiting = false;
                    setTimeout(() => { self.sent.show = false; self.received.show = false; }, 3000);
                }
            }, 1000);
        },

        stopDelayTimer() {
            if (this.delayTimerInterval) { clearInterval(this.delayTimerInterval); this.delayTimerInterval = null; }
        },

        formatTimeRemaining(seconds) {
            let h = Math.floor(seconds / 3600);
            let m = Math.floor((seconds % 3600) / 60);
            let s = seconds % 60;
            if (h > 0) return h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
            return m + ':' + (s < 10 ? '0' : '') + s;
        },

        formatExpirationTime(isoString) {
            if (!isoString) return '';
            let d = new Date(isoString);
            return (d.getHours() < 10 ? '0' : '') + d.getHours() + ':' + (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
        },

        getCourtesyLabel(rating) {
            // Aligné sur User::getCourtesyGradeAttribute (échelle 1-12).
            const labels = { 1:'F', 2:'E-', 3:'E', 4:'D', 5:'D+', 6:'C', 7:'C+', 8:'B', 9:'B+', 10:'A', 11:'A+', 12:'S' };
            return labels[rating] || 'C';
        },

        getPassAssistanceLabel(pa) {
            if (!pa) return null;
            const map = { 'FUMA': 'FUMA', 'FUTO1': 'FUTO 1', 'FUTO2': 'FUTO 2', 'FUTO3': 'FUTO 3' };
            return map[pa] || pa;
        },

        /**
         * Étoiles d'ÉQUIPE (niveau), au barème du jeu : piste de 5 slots, jamais plus.
         * La valeur arrive déjà calculée du serveur (App\Support\StarRating appliqué
         * à la note d'effectif) — ne rien recalculer ici. La réputation, elle, se lit
         * en points : elle n'a plus d'étoiles.
         */
        teamStars(stars) {
            if (!stars) return '';
            let full = Math.floor(stars);
            let half = (stars % 1) >= 0.5 ? 1 : 0;
            let empty = 5 - full - half;
            let s = '';
            for (let i = 0; i < full; i++) s += '<i class="material-icons star-full">star</i>';
            if (half) s += '<i class="material-icons star-half">star_half</i>';
            for (let i = 0; i < empty; i++) s += '<i class="material-icons star-empty">star_border</i>';
            return s;
        },

        startRankingPolling() {
            this.stopRankingPolling();
            let self = this;
            this.rankingCheckInterval = setInterval(function () {
                fetch('/ranking/check-challenge?ranking_match_id=' + self.rankingSent.rankingMatchId)
                    .then(r => r.json())
                    .then(data => {
                        if (!data.success || data.status === 'waiting') return;

                        if (data.status === 'accepted' && data.redirect) {
                            self.stopRankingPolling();
                            self.rankingSent.status = 'accepted';
                            self.rankingSent.message = 'Défi accepté !';
                            self.rankingSent.waiting = false;
                            setTimeout(() => { window.location.href = data.redirect; }, 1500);
                        } else if (data.status === 'delay_proposed') {
                            self.stopRankingPolling();
                            self.rankingSent.status = 'delay_proposed';
                            self.rankingSent.hasDelayProposal = true;
                            self.rankingSent.proposedDelay = data.proposed_delay;
                            self.rankingSent.message = '';
                            self.rankingSent.waiting = false;
                        } else if (data.status === 'delay_waiting' && data.delay_info) {
                            self.stopRankingPolling();
                            self.rankingSent.status = 'delay_waiting';
                            self.rankingSent.delayInfo = data.delay_info;
                            self.rankingSent.timeRemaining = data.delay_info.time_remaining;
                            self.rankingSent.message = 'Délai accepté. En attente...';
                            self.rankingSent.waiting = false;
                            self.startRankingDelayTimer();
                        } else if (data.status === 'delay_expired') {
                            self.stopRankingPolling();
                            self.rankingSent.status = 'delay_expired';
                            self.rankingSent.message = 'Le délai est passé.';
                            self.rankingSent.delayInfo = null;
                            self.rankingSent.waiting = false;
                            setTimeout(() => { self.rankingSent.show = false; }, 3000);
                        } else if (data.status === 'refused') {
                            self.stopRankingPolling();
                            self.rankingSent.status = 'refused';
                            self.rankingSent.message = data.message || 'Le défi a été refusé.';
                            self.rankingSent.waiting = false;
                        }
                    })
                    .catch(err => console.error(err));
            }, 3000);
        },

        stopRankingPolling() {
            if (this.rankingCheckInterval) { clearInterval(this.rankingCheckInterval); this.rankingCheckInterval = null; }
        },

        startRankingDelayTimer() {
            this.stopRankingDelayTimer();
            let self = this;
            this.rankingDelayTimerInterval = setInterval(function () {
                if (self.rankingSent.timeRemaining > 0) {
                    self.rankingSent.timeRemaining--;
                } else {
                    self.stopRankingDelayTimer();
                    self.rankingSent.message = 'Le délai est passé. Vous pouvez relancer le défi.';
                    self.rankingSent.status = 'delay_expired';
                    self.rankingSent.delayInfo = null;
                    self.rankingSent.waiting = false;
                    setTimeout(() => { self.rankingSent.show = false; }, 3000);
                }
            }, 1000);
        },

        stopRankingDelayTimer() {
            if (this.rankingDelayTimerInterval) { clearInterval(this.rankingDelayTimerInterval); this.rankingDelayTimerInterval = null; }
        },

        respondToRankingDelay(rankingMatchId, accept) {
            let self = this;
            this._postMatch('/ranking/respond-to-ranking-delay', { ranking_match_id: rankingMatchId, accept: accept }, data => {
                if (!data.success) return;
                self.rankingSent.hasDelayProposal = false;
                if (accept && data.delay_info) {
                    self.rankingSent.message = 'Délai accepté. En attente...';
                    self.rankingSent.status = 'delay_waiting';
                    self.rankingSent.delayInfo = data.delay_info;
                    self.rankingSent.timeRemaining = data.delay_info.time_remaining;
                    self.startRankingDelayTimer();
                } else {
                    self.rankingSent.message = 'Délai refusé. En attente de réponse...';
                    self.rankingSent.status = 'waiting';
                    self.rankingSent.waiting = true;
                    self.startRankingPolling();
                }
            });
        },

        closeRankingSentPopup() {
            this.stopRankingPolling();
            this.stopRankingDelayTimer();
            this.rankingSent.show = false;
        },

        startRankingReceivedTimer() {
            this.stopRankingReceivedTimer();
            let self = this;
            this.rankingReceivedTimerInterval = setInterval(function () {
                if (self.rankingReceived.timeRemaining > 0) {
                    self.rankingReceived.timeRemaining--;
                } else {
                    self.stopRankingReceivedTimer();
                    self.rankingReceived.show = false;
                }
            }, 1000);
        },

        stopRankingReceivedTimer() {
            if (this.rankingReceivedTimerInterval) { clearInterval(this.rankingReceivedTimerInterval); this.rankingReceivedTimerInterval = null; }
        },

        acceptRankingChallenge(rankingMatchId, chosenMode) {
            let self = this;
            this.stopRankingReceivedTimer();
            let body = { ranking_match_id: rankingMatchId, accept: true };
            if (chosenMode) body.chosen_mode = chosenMode;
            this._postMatch('/ranking/respond-to-challenge', body, data => {
                if (data.success && data.redirect) { window.location.href = data.redirect; return; }
                // Défi expiré/refusé côté serveur : on ferme le popup.
                if (!data.success) self.rankingReceived.show = false;
            });
        },

        refuseRankingChallenge(rankingMatchId) {
            let self = this;
            this.stopRankingReceivedTimer();
            this._postMatch('/ranking/respond-to-challenge', { ranking_match_id: rankingMatchId, accept: false }, data => {
                self.rankingReceived.show = false;
            });
        },

        proposeRankingDelay(rankingMatchId, minutes) {
            let self = this;
            this.stopRankingReceivedTimer();
            this._postMatch('/ranking/respond-to-challenge', { ranking_match_id: rankingMatchId, propose_delay: minutes }, data => {
                self.rankingReceived.show = false;
                self.rankingReceived.showDelayChoice = false;
            });
        },

        _postMatch(url, body, callback) {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify(body)
            })
                .then(r => r.json())
                .then(callback)
                .catch(err => console.error(err));
        }
    };
};
